import { createSelector } from 'reselect';
import { getActiveSubLayerId, getCurrentLayer } from './layerSelectors';

/**
 * Get other imagery layers grouped by vendor names
 * @param {object} state - The redux root state.
 * @param {object} props - Own props of the component.
 * @return {object} other imagery layers grouped by names of vendors
 */
export const getVendorLayers = createSelector(
  getCurrentLayer,
  // eslint-disable-next-line no-unused-vars
  ({ activeSubLayerIds, ...vendorLayers }) => vendorLayers
);

const getLayerIdsInOrder = createSelector(getVendorLayers, (vendorLayers) => {
  const idOrder = [];
  Object.keys(vendorLayers).forEach((vendor) => {
    const layers = vendorLayers[vendor];
    Object.keys(layers).forEach((layer) => {
      layers[layer].forEach((_, i) => {
        idOrder.push({
          vendor,
          layer,
          index: i,
        });
      });
    });
  });

  return idOrder;
});

const findCurrentEvent = (ids, currentId) =>
  ids.findIndex(
    ({ vendor, layer, index }) =>
      vendor === currentId.vendor &&
      layer === currentId.layer &&
      index === currentId.index
  );

export const getNextEventId = createSelector(
  [getLayerIdsInOrder, getActiveSubLayerId],
  (ids, currentId) => {
    const i = findCurrentEvent(ids, currentId);
    return i === ids.length - 1 ? currentId : ids[i + 1];
  }
);

export const getPrevEventId = createSelector(
  [getLayerIdsInOrder, getActiveSubLayerId],
  (ids, currentId) => {
    const i = findCurrentEvent(ids, currentId);
    return i === 0 ? currentId : ids[i - 1];
  }
);
